export default {
    newsletterValidation() {
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        $(document).on('submit', '.newsletter--input-form', function (e) {
            e.preventDefault();
            let loader = $('.newsletter--input-form .loader-holder');
            let checkMark = $('.newsletter--input-form .form-checkbox');
            let errorMsg = $('.newsletter--input-form .error-message');
            let successMsg = $('.newsletter--input-form .success-message');
            errorMsg.hide();
            successMsg.hide();
            loader.show();
            let validation = true;
            let contactEmail = $('.newsletter--input-form .form-email');


            $(".form-input.req", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });

            if ($('.newsletter--input-form .rules').is(":checked")) {
                checkMark.removeClass('input-invalid');
            } else {
                checkMark.addClass('input-invalid');
                validation = false;
            }

            let value = contactEmail.val();
            let valid = validateEmail(value);
            if (!valid) {
                contactEmail.closest('.form-item').addClass('input-invalid');
                validation = false;
            } else {
                contactEmail.closest('.form-item').removeClass('input-invalid');
            }

            if (validation == true) {
                successMsg.slideDown(300);
            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },
}